import { GoStop } from "react-icons/go";
import { BsArrowCounterclockwise } from "react-icons/bs";
import { FaUserInjured } from "react-icons/fa";
import { BiError } from "react-icons/bi";
import { ImHourGlass } from "react-icons/im";
import { FaBusinessTime } from "react-icons/fa";
import {
  GiSandsOfTime,
  GiHazardSign,
  GiBackwardTime,
  GiHeartBeats,
  GiFalling,
  GiMedicalPackAlt,
} from "react-icons/gi";
// import { TbFall } from "react-icons/tb";
import { FaClinicMedical } from "react-icons/fa";
// import { MdOutlinePendingActions } from "react-icons/md";
// import { MdNearbyError } from "react-icons/md";
//import { faHandHoldingMedical } from "@fortawesome/free-solid-svg-icons";
// import { MdPersonalInjury,MdOutlinePendingActions } from "react-icons/md";

export const widgetData = [
  {
    name: "Total Incidents",
    value: "totalReportedIncidents",
    icon: BsArrowCounterclockwise,
  },
  { name: "Hours Since Last LTI", value: "timeSinceLastLTIWidget", icon: GiBackwardTime },
  { name: "Total LTI hours", value: "totalLTIhours", icon: ImHourGlass },
  { name: "OverDue CAPAs", value: "overDueCAPAs", icon: GiSandsOfTime },
  { name: "Unsafe Act", value: "unsafeAct", icon: GiHazardSign },
  { name: "Unsafe Condition", value: "unsafeCondition", icon: BiError },
  {
    name: "Near Miss",
    value: "nearMiss",
    icon: GiFalling,
  },
  { name: "MTI", value: "mti", icon: GiMedicalPackAlt },
  { name: "Lost Time Injury", value: "lti", icon: FaUserInjured },
  { name: "Serious Bodily Injury", value: "seriousBInjury", icon: FaClinicMedical },
  { name: "Fatality", value: "fatality", icon: GiHeartBeats },
  { name: "Outstanding CAPAs", value: "outstandingCAPAs", icon: FaBusinessTime },
];
export const pageTwoChartList = [
  { title: "Incidents - By Type", value: "incidentTypes", type: "pie" },
  { title: "Incidents - By Severity", value: "incidentSeverity", type: "pie" },
  {
    title: "Incidents - By Time of Day",
    value: "incidentOnThreeHoursIntervals",
    type: "pie",
  },
  {
    title: "Incidents - By Top 5 Areas",
    value: "incidentByArea",
    type: "pie",
  },
  {
    title: "Incidents - By Top 5 Subareas",
    value: "incidentBySubArea",
    type: "pie",
  },
  {
    title: "Incidents - By Top 5 Activities",
    value: "incidentByActivity",
    type: "pie",
  },
  // {
  //   title: "Incident Subactivity wise - Top 5",
  //   value: "incidentBySubActivity",
  //   type: "pie",
  // },
  {
    title: "Incidents - By Worker Type",
    value: "incidentByStaffType",
    type: "pie",
  },
  {
    title: "Incidents - By Shifts",
    value: "incidentByShift",
    type: "pie",
  },
  {
    title: "Incidents - By Departments",
    value: "incidentByDepartment",
    type: "pie",
  },

  {
    title: "Incidents -  Personal/Equipment/Vehicle",
    // yAxisName: "Count",
    // xAxisName: "Site",
    value: "incidentByInvolving",
    type: "pie",
  },
  {
    title: "Incidents - Top 5 Injury Type",
    value: "incidentByInjuryType",
    type: "pie",
  },
  // {
  //   title: "Injury Body Part wise",
  //   value: "incidentByInjuryBody",
  //   type: "pie",
  // },
  {
    title: "Outstanding CAPAs - Top 5 Area Owners",
    value: "outstandingCAPAsAreaOwnerWise",
    type: "pie",
  },
  {
    // changes to Pie
    title: "Overdue CAPAs - Top 5 Area Owners",
    value: "overDueCAPAsAreaOwnerWise",
    type: "pie",
  },
  // {
  //   title: "Outstanding CAPAs Area wise",
  //   value: "outstandingCAPAsAreaWise",
  //   type: "pie",
  // },

  // {
  //   title: "Root Causes - Top 5",
  //   value: "incidentBYRootCause",
  //   type: "pie",
  // },
  {
    name: "Incidents - Top 5 Employees",
    yAxisName: "Count",
    xAxisName: "Employee",
    value: "incidentByEmployee",
    type: "barWithCustomTooltip",
  },
  {
    name: "Incidents - Top 5 Contractors",
    yAxisName: "Count",
    xAxisName: "Contractor",
    value: "incidentByContractor",
    type: "barWithCustomTooltip",
  },
  {
    name: "Incidents - Top 5 Contractor Staff",
    yAxisName: "Count",
    xAxisName: "Contractor Staff",
    value: "incidentByContractorStaff",
    type: "barWithCustomTooltip",
  },
  {
    title: "EHS Pyramid",
    value: "IncidentEHSPyramid",
    type: "pyramid",
  },
  {
    name: "Body Parts (Front + Back)",
    value: "bodyPartWiseIncident",
    type: "bodyPart",
  },
];

export const pageOneChartList = [
  // {
  //   name: "Incidents - By Severity - All Locations",
  //   yAxisName: "",
  //   xAxisName: "",
  //   value: "severityWiseIncidentHO",
  //   type: "bar",
  //   isRO: false,
  // },
  {
    name: "Incidents - By Severity - All Locations",
    yAxisName: "Count",
    xAxisName: "Severity",
    value: "severityWiseIncidentHO",
    type: "barWithLabel",
    isRO: false,
    isHo: false,
  },
  {
    name: "Incidents - By Type - All Locations",
    yAxisName: "Count",
    xAxisName: "",
    value: "typeWiseIncidentHO",
    type: "barWithLabel",
    isRO: false,
    isHo: false,
  },
  {
    name: "Incidents - By Severity - Regional Offices",
    yAxisName: "Count",
    xAxisName: "",
    value: "severityWiseIncidentRO",
    type: "stack",
    isRO: true,
    isHo: true,
  },
  {
    name: "Incidents - By Type - Regional Offices",
    yAxisName: "Count",
    xAxisName: "",
    value: "typeWiseIncidentRO",
    type: "stack",
    isRO: true,
    isHo: true,
  },
  {
    name: "Incident - By Severity - Mines",
    yAxisName: "Count",
    xAxisName: "",
    value: "severityWiseIncidentMM",
    type: "stack",
    isRO: true,
    isMines: true,
    isHo: false,
  },
  {
    name: "Incidents - By Type - Mines",
    yAxisName: "Count",
    xAxisName: "",
    value: "typeWiseIncidentMM",
    type: "stack",
    isRO: true,
    isMines: true,
    isHo: false,
  },
  {
    title: "Outstanding CAPAs - All Locations",
    value: "outstandingCAPAsHO",
    type: "pieVs",
    isRO: false,
    isHo: false,
  },
  {
    title: "Overdue CAPAs - All Locations",
    value: "overdueCAPAsHO",
    type: "pieVs",
    isRO: false,
    isHo: false,
  },
  {
    name: "CAPA Status - Regional Offices",
    yAxisName: "Count",
    xAxisName: "",
    value: "outstandingCAPAsRo",
    type: "stack",
    isRO: true,
    isMines: true,
    isHo: true,
  },
  // {
  //   name: "Overdue CAPAs - Regional Offices",
  //   yAxisName: "Count",
  //   xAxisName: "Site",
  //   value: "overdueCAPAsRo",
  //   type: "barWithLabel",
  //   isRO: true,
  // },
  {
    name: "CAPA  Status - Mines",
    yAxisName: "Count",
    xAxisName: "",
    value: "outstandingCAPAsMM",
    type: "stack",
    isRO: true,
    isMines: true,
    isHo: false,
  },
  // {
  //   name: "Overdue CAPAs - Mines",
  //   yAxisName: "Count",
  //   xAxisName: "Site",
  //   value: "overdueCAPAsMM",
  //   type: "barWithLabel",
  //   isRO: true,
  //   isMines: true,
  // },
];

export const pyramidKeyColour = {
  nearMissMti: "#e7404a",
  unsafeActUnsafeCondition: "rgb(47 69 84)",
  lti: "rgb(97 160 168)",
  seriousBInjury: "rgb(202 134 35)",
  fatality: "rgb(145 199 174)",
};
